// extracted by mini-css-extract-plugin
module.exports = {"logo":"TenantLogo_logo__pzEm3"};